import { Component } from '@angular/core';

@Component({
  selector: 'dashboard-container',
  templateUrl: './dashboard-container.component.html',
  styleUrls: ['./dashboard-container.component.scss'],
  standalone: false,
})
export class DashboardContainerComponent {
  public constructor() {}

  public TEMP_UNTIL_OTHER_TABS = false; // TO BE REMOVED ONCE OTHER VIEW MODES ARE DEVELOPED
  public viewMode = ViewMode.Contract;

  public switchHandler(tab: string) {
    this.viewMode = ViewMode[tab];
  }
}

enum ViewMode {
  Contract,
  Asset,
  Request,
}
